module.exports = __webpack_public_path__ + "img/placeholder.9635bc6f.png";